var render = function render(){var _vm=this,_c=_vm._self._c;return (this.dataList.descripcion)?_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-card',{staticClass:"mt-4 section-wrap pa-3"},[_c('div',{staticClass:"cient-details-wrapper text-center"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(this.mainHeading))]),_vm._v(" "+_vm._s(this.subHeading)+" ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }